module.exports = __webpack_public_path__ + "static/media/readAction.785e4823.svg";